<template>
  <div class="history-body history-area">
    <search-header
      ref="searchHeader"
      :query="query"
      :need-input-search="needInputSearch"
      @search="search"
    />
    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      :expand-row-keys="expandKeys"
      style="width: 100%"
      row-key="id"
      @selection-change="getSelection"
      @expand="expandToggle"
      @sort-change="sortChange"
    >
      <el-table-column
        :selectable="selectable"
        type="selection"
        width="35"
      />
      <el-table-column
        :render-header="renderExpandHeader"
        label-class-name="show-all-label"
        min-width="240"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.locked && !isLogin"
            class="lock-icon"
          />
          <p
            :title="scope.row.title"
            class="pointer over-hidden-text"
            @click="toDetail(scope.row)"
            v-html="scope.row.htmlTitle"
          />
        </template>
      </el-table-column>

      <!-- 展开显示暂时隐藏，需要提取关键词做好后显示 -->
      <!-- <el-table-column
          type="expand"
          width="30"
        >
          <template slot-scope="scope">
            <div class="expand-table-content">
              <label>摘要：</label>
              <p>{{ scope.row.summary }}</p>
            </div>
            <div class="expand-table-content margin-top10">
              <label>关键词：</label>
              <p>{{ scope.row.hotwords }}</p>
            </div>
          </template>
        </el-table-column> -->
      <el-table-column
        prop="label"
        label="标签"
        width="200"
      >
        <template slot-scope="scope">
          <span
            v-for="(item, index) in scope.row.label"
            :key="index"
            :class="{'user-custom-label': item !== '无'}"
          >{{ item }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="domain"
        label="领域"
        width="180"
      /> -->
      <el-table-column
        prop="attribute"
        label="属性"
        width="180"
      />
      <el-table-column
        prop="author"
        label="作者"
        width="100"
      />
      <el-table-column
        prop="date"
        label="日期"
        width="120"
        sortable="custom"
      />
    </el-table>

    <!-- 操作区和分页区 -->
    <div>
      <el-button
        type="text"
        class="margin-top16"
        @click="download"
        :disabled="true"
      >下载</el-button>
      <el-pagination
        :current-page.sync="pageConfig.pageIndex"
        :page-sizes="[10, 20, 50]"
        :page-size="pageConfig.pageSize"
        :total="pageConfig.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChange"
        @current-change="loadData"
      />
    </div>
    <!-- </div> -->
    <div class="clearfix" />

    <download-dialog
      :dialog-visible="downloadDialogVisible"
      @cancel-download="cancelDownload"
      @confirm-download="downloadFromServer"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import searchComponent from '@/components/searchComponent'
import searchHeader from '@/modules/history/history-area/search-header'
import downloadDialog from '@/modules/history/history-area/downloadDialog'

import { domainService, knowledgeBaseService } from '@/service/httpService'
import { globalService } from '@/service/globalService'

export default {
  name: 'HistoryArea',
  components: {
    searchComponent,
    searchHeader,
    downloadDialog
  },
  data () {
    // 初始化路由参数
    return {
      tableData: [],
      selectRows: [],
      expandKeys: [],
      pageConfig: {
        total: 0,
        pageIndex: 1,
        pageSize: 10
      },
      downloadDialogVisible: false,
      loading: false,
      needInputSearch: false,

      // 搜索参数配置
      query: {
        beginTime: null,
        endTime: null,
        attribute: '',
        titles: [],
        orderByPublishTime: 1,
        mainContents: [],
        titleAndMainContent: [],
        tags: [],
        sources: [],
        sourceNames: []
      }
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  watch: {
    expandKeys (val) {
      this.setExpandShow(val)
    }
  },
  mounted () {
    let query = this.$route.query
    if (query.type && query.content) {
      this.wordSearch ({
        searchType: query.type,
        searchText: query.content
      })
    } else {
      this.loadData()
    }    
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),

    // 全局组件搜索
    wordSearch (data) {
      this.$refs.searchHeader.search(data)
    },

    // 搜索：条件搜索
    search (searchParam) {
      this.query = {
        ...this.query,
        ...searchParam
      }
      this.pageConfig.pageIndex = 1
      this.loadData()
    },

    // 关键词高亮
    highLight (query, data, key) {
      let keyword = [
        ...query.titles,
        ...query.mainContents,
        ...query.titleAndMainContent,
        ...query.tags,
        ...query.sources,
        ...query.sourceNames
      ]

      let regStr = keyword.join('|')
      let reg = new RegExp(regStr, 'gim')

      if (regStr) {
        data.forEach(item => {
          item[key] = item[key].replace(reg, '<span class="hight-light-word">$&</span>')
        })
      }
    },
    pageSizeChange (val) {
      this.pageConfig.pageSize = val
      this.loadData()
    },
    loadData () {
      let endTime = this.query.endTime

      // 如果选择了日期 在结束日期加时间点 不用默认的00:00:00
      if (endTime) {
        endTime = window.moment(this.query.endTime).format('YYYY-MM-DD') + ' 23:59:59'
        endTime = new Date(endTime)
      }

      let param = {
        ...this.query,
        pageIndex: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        endTime: endTime
      }

      this.loading = true

      domainService.searchData(param)
        .then(res => {
          let dist = []
          let data = res.data.Data
          data.forEach(item => {
            let attribute = [item.PropertyLevel1, item.PropertyLevel2]
            attribute = attribute.filter(data => {
              return data
            })
            dist.push({
              id: item.DocumentId,
              title: item.Title,
              htmlTitle: item.Title,
              domain: item.Region || '无',
              label: (item.UserDefineTags && item.UserDefineTags.length) ? item.UserDefineTags : ['无'],
              attribute: attribute.length ? attribute.join('->') : '无',
              author: item.Author || '无',
              date: window.moment(item.PublishTime).format('YYYY-MM-DD'),
              summary: item.Summary || '无',
              hotwords: (item.HotwordList && item.HotwordList.length) ? item.HotwordList.join('、') : '无',
              locked: item.Locked
            })
          })
          this.highLight(param, dist, 'htmlTitle')
          this.tableData = dist
          this.pageConfig.total = res.data.Total

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // table相关的方法
    selectable (row) {
      // if (!this.isLogin && row.locked) {
        return false
      // }
      // return true
    },
    sortChange( sortObj) {
      const {order} = sortObj
      if (order === 'ascending') {
        this.search({
          orderByPublishTime: 1
        })
        return true
      }
      this.search({
        orderByPublishTime: 0
      })
    },
    getSelection (selection) {
      this.selectRows = selection
    },
    cancelDownload () {
      this.downloadDialogVisible = false
    },
    download () {
      if (!this.selectRows.length) {
        this.$message({ type: 'info', message: '您还没有选择数据' })
        return false
      }
      this.downloadDialogVisible = true
    },
    downloadFromServer (type) {
      this.downloadDialogVisible = false
      let ids = globalService.getPrimaryKeyArray(this.selectRows, 'id')

      // type: 1 下载文章 2 下载摘要列表
      if (type === '1') {
        knowledgeBaseService.download(ids)
      } else {
        knowledgeBaseService.downloadExcel(ids)
      }
    },
    expandAll () {
      this.expandKeys = globalService.getPrimaryKeyArray(this.tableData, 'id')
      this.tableData.forEach(item => {
        item.expand = true
      })
    },
    folderAll () {
      this.expandKeys = []
      this.tableData.forEach(item => {
        item.expand = false
      })
    },
    expandToggle (row, expand) {
      row.expand = expand
      let expands = this.tableData.filter(item => {
        return item.expand
      })
      this.expandKeys = globalService.getPrimaryKeyArray(expands, 'id')
    },
    renderExpandHeader (h, { column, $index }) {
      //  <a
      //       class="pointer expand-operate"
      //       on-click={() => { this.expandAll() }}
      //     >（一键展开/收起摘要）<i class="el-icon-arrow-right"></i></a>
      //     <a
      //       class="pointer folder-operate"
      //       style="display:none"
      //       on-click={() => { this.folderAll() }}
      //     >（一键展开/收起摘要）<i class="el-icon-arrow-down"></i></a>

      // 一键展开和收起隐藏，放开请加在标题后面
      return (
        <div class="expand-toggle-all">
          <span>标题</span>
        </div>
      )
    },
    // 设置一键展开、收起的显示和隐藏，因为table里面渲染的jsx不能使用v-show等指令，只能样式设置
    setExpandShow (val) {
      let expandDom = document.querySelector('.expand-operate')
      let folderDom = document.querySelector('.folder-operate')
      if (val.length === this.tableData.length) {
        expandDom.style.display = 'none'
        folderDom.style.display = 'block'
      } else {
        expandDom.style.display = 'block'
        folderDom.style.display = 'none'
      }
    },

    // 跳转到详情
    toDetail (row) {
      if (row.locked && !this.isLogin) {
        this.loginShow()
        return false
      }

      const { href } = this.$router.resolve({
        path: 'article/' + row.id,
        query: {
          title: encodeURIComponent(row.title)
        }
      })
      window.open(href)
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/modules/fullLibSearch-out/dataList.vue